<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrighta"><a id="page_iv"></a>Published by The University of Georgia Press<br/>
  Athens, Georgia 30602<br/>
  © 1994 by Chrisanne Fuhrman<br/>
  All rights reserved<br/>
  Designed by Erin Kirk New<br/>
  Set in 10.5 on 14 Berkeley Old Style Medium<br/>
  by Tseng Information Systems, Inc.</p>
<p class="copyright">The paper in this book meets the guidelines for permanence<br/>
  and durability of the Committee on Production Guidelines<br/>
  for Book Longevity of the Council on Library Resources.</p>
<p class="copyright">Printed in Canada</p>
<p class="copyright">08 09 10 11 12 P 11 10 9 8 7</p>
<p class="copyright"><em>The Library of Congress has cataloged the hardcover edition of this book as follows:</em></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>
  Fuhrman, Chris.<br/>
  The dangerous lives of altar boys : a novel / by Chris Fuhrman<br/>
  viii, 187 p. ; 23 cm.<br/>
  ISBN 0-8203-1632-6 (alk. paper)<br/>
  1. Boys—Fiction.<br/>
  2. Catholics—Fiction.<br/>
  3. Savannah (Ga.)—Fiction.</p>
<p class="copyright1">I. Title.</p>
<p class="copyright1">PS3556.U3245 D36 1994</p>
<p class="copyright1">813’.54—dc20    93-41113</p>
<p class="copyright">Paperback ISBN-13: 978-0-8203-2338-1<br/>
  ISBN-10: 0-8203-2338-1</p>
<p class="copyright">British Library Cataloging-in-Publication Data available</p>
<p class="copyright">“Thirteen,” “The Usual Gang of Idiots,” and “A Priest with a<br/>
  Girlfriend” were first published in <em>Columbia: A Magazine of<br/>
  Poetry &amp; Prose,</em> no. 17 (Fall 1991): 201-30.</p>
<p class="copyright"><strong>ISBN for this digital edition: 978-0-8203-3585-8</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?26ab64d3